module.exports = __webpack_public_path__ + "img/active.17c54b80.png";